import {
    withHeaders,
    instance as axiosInstance,
} from '../core/util/axiosInstance';
import { getDefaultHeaders, useAlert } from '../core';
import { MutationFunction, UseMutationResult, useMutation } from 'react-query';
import { AxiosResponse } from 'axios';
import { commonShowAlert } from '../lib';
import { AttributeAssociationItem } from '../pages/edge-definitions/edge-definition-helper';
import { FILE_UPLOAD_SUCCESS_MSG } from '../pages/job-manager/job-manager-helper';

interface PostExecuteSmartContractProps {
    token: string;
    chain: string;
    sdoId: string;
    func: string;
    args?: AttributeAssociationItem[];
}

export const postExecuteSmartContract: MutationFunction<
    AxiosResponse<any>,
    PostExecuteSmartContractProps
> = async (props: PostExecuteSmartContractProps) => {
    const { token, chain, sdoId, func, args = [] } = props;
    const headers = getDefaultHeaders(token);
    const executeSmartContractJobUrl = `/jobs/${chain}/smartcontracts/${sdoId}/${func}`;

    const formData = new FormData();
    formData.append('chain', chain);
    formData.append('sdoId', sdoId);
    formData.append('func', func);
    args.forEach((item) => {
        formData.append(
            item.attributeAssociation.leftSideValue,
            item.attributeAssociation.rightSideValue
        );
    });

    return axiosInstance().post(
        executeSmartContractJobUrl,
        formData,
        withHeaders(headers)
    );
};

export const useExecuteSmartContract = (
    successMessage?: string
): UseMutationResult<
    AxiosResponse<any>,
    unknown,
    PostExecuteSmartContractProps
> => {
    const { showAlert, hideAlert, showErrorDetails } = useAlert();

    return useMutation(postExecuteSmartContract, {
        onSuccess: () => {
            commonShowAlert(
                showAlert,
                hideAlert,
                'success',
                successMessage ?? FILE_UPLOAD_SUCCESS_MSG
            );
        },
        onError: (error: any) => {
            const errorMessage: string =
                error?.data?.message ?? 'Unable to execute smart contract job';
            commonShowAlert(
                showAlert,
                hideAlert,
                'error',
                errorMessage,
                JSON.stringify(error?.data ?? ''),
                showErrorDetails
            );
        },
    });
};
